import {Component, Inject} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { USER_ROLE, User, getUserRoleName } from '../../common/user';

// what each organisation role allows, shown under the role picker
const ROLE_DESCRIPTIONS:{ [role:number]: string } = {
    [USER_ROLE.ADMIN]: 'Can manage the organisation, its users, billing and backups, as well as edit models.',
    [USER_ROLE.WRITE]: 'Can create and edit projects and models.',
    [USER_ROLE.READ]: 'Can view projects and models but not change them.',
}

@Component({
    selector: 'app-organisation-user-dialog',
    templateUrl: 'organisation-user-dialog.html',
    styleUrls: ['organisation-user-dialog.css'],
    standalone: false
})
export class OrganisationUserDialogComponent {
    roleControl:FormControl<USER_ROLE>
    roles = [USER_ROLE.ADMIN, USER_ROLE.WRITE, USER_ROLE.READ]
    invalidRoleMessage:string

    constructor(public dialogRef: MatDialogRef<OrganisationUserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {users:User[], user:User}) {

        this.roleControl = new FormControl<USER_ROLE>(data.user.role, Validators.required);
    }

    // closes with the chosen role; the caller saves it
    save() {
        this.checkRole()
        if (this.roleControl.valid && !this.invalidRoleMessage) {
            this.dialogRef.close(this.roleControl.value);
        }
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    isUnchanged() {
        return this.roleControl.value === this.data.user.role
    }

    getRoleName(role:USER_ROLE) {
        return getUserRoleName(role)
    }

    getRoleDescription(role:USER_ROLE) {
        return ROLE_DESCRIPTIONS[role]
    }

    checkRole() {
        const lastAdmin = this.data.user.role === USER_ROLE.ADMIN && this.data.users.filter(u => u.role === USER_ROLE.ADMIN).length <= 1
        this.invalidRoleMessage = lastAdmin && this.roleControl.value !== USER_ROLE.ADMIN
            ? "This is the organisation's only admin. Make another user an admin first."
            : undefined
    }
}
